import React from "react";
import Select from 'react-select';

import Grid from "../../../layout/grid/grid";


export class SelectLabel extends React.PureComponent {
	render() {
		const {
			meta: { touched, error }, options
		} = this.props;
		const topLabel = (this.props.label ? {top: 78} : {top: 50})
		return (
			<Grid cols={this.props.cols} style={this.props.style}>
				<div
					className={`form-group ${touched && error && "has-error"}`}
					style={{padding: '0 0 0.6rem 0'}}
				>
					{this.props.label ?
						touched && error ? (
							<label className="control-label">
								<i className="fa fa-times-circle-o" />
								&nbsp;
								{this.props.label}
							</label>
						) : (
							<label htmlFor={this.props.name}>
								{this.props.label}
							</label>
						)
					: null
					}
					<Select
						{...this.props.input}
						value={this.props.input.value}
						onBlurResetsInput={false}
						// onBlur={() => this.props.input.onBlur(this.props.input.value)}
						onBlur={event => event.preventDefault()}
						isMulti={this.props.isMulti}
						options={options}
						className="form-control basic-multi-select"
						classNamePrefix="select"
						isDisabled={this.props.readOnly}
						placeholder={this.props.placeholder}
						isClearable={this.props.isClearable}
						isSearchable={true}
						style={{ input: () => this.props.selectStyle}}
					/>
					{touched && error && (
						<span className="help-block" style={topLabel}>{error}</span>
					)}
				</div>
			</Grid>
		);
	}
}